"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_apexcharts_1 = __importDefault(require("react-apexcharts"));
const CircularProgress_1 = __importDefault(require("@mui/material/CircularProgress"));
const common_1 = require("@components/common");
const useTargetChart_1 = require("../hooks/useTargetChart");
const dateUtils_1 = require("@app/utils/dateUtils");
const locale_1 = __importDefault(require("../locale"));
const useTargetExerciseContext_1 = require("@app/routes/Dashboard/hooks/useTargetExerciseContext");
const ChartSelect_1 = require("@components/form/ChartSelect");
const useChartsDateFilterContext_1 = require("@app/routes/Dashboard/hooks/useChartsDateFilterContext");
const TargetLines = () => {
    const { targets, fetchTargetChart, exerciseList, fetchExerciseList, isLoading, exerciseKey, selectExercise, isDataLoading, resetExerciseKey } = (0, useTargetChart_1.useTargetChart)();
    const { targetExercise, setTargetExercise } = (0, useTargetExerciseContext_1.useTargetExerciseContext)();
    const { filterState } = (0, useChartsDateFilterContext_1.useChartsDateFilterContext)();
    (0, react_1.useEffect)(() => {
        resetExerciseKey();
        fetchExerciseList({
            range: {
                fromDate: filterState.fromDate,
                toDate: filterState.toDate
            }
        });
    }, [filterState.fromDate, filterState.toDate]);
    (0, react_1.useEffect)(() => {
        if (!isLoading && exerciseKey)
            fetchTargetChart({
                range: {
                    fromDate: filterState.fromDate,
                    toDate: filterState.toDate
                },
                exerciseKey
            });
    }, [exerciseKey, isLoading]);
    (0, react_1.useEffect)(() => {
        if (targets && targetExercise && exerciseList.find(e => e.slug === targetExercise)) {
            selectExercise(targetExercise);
        }
    }, [targetExercise]);
    const handleExerciseChange = (ev) => {
        selectExercise(ev.target.value);
        setTargetExercise(null);
    };
    if (!targets)
        return null;
    let labels = [];
    let dataTarget = [];
    let dataEstimate = [];
    // @ts-ignore
    targets === null || targets === void 0 ? void 0 : targets.forEach(e => {
        labels.push(e === null || e === void 0 ? void 0 : e.date);
        dataTarget.push(Number((e === null || e === void 0 ? void 0 : e.target) * 100).toFixed(2));
        dataEstimate.push(Number((e === null || e === void 0 ? void 0 : e.repetition_value) * 100).toFixed(2));
    });
    const buildTargetsParamsString = ({ dataPointIndex }) => 
    // @ts-ignore
    targets === null || targets === void 0 ? void 0 : targets[dataPointIndex].target_values_info.map(e => `\n\r${e.target_key} ${Number(e.value * 100).toFixed(0)}%`).join('; ');
    const targetsState = {
        series: [
            {
                name: locale_1.default.estimateLabel,
                data: dataEstimate,
                type: 'column'
            },
            {
                name: locale_1.default.targetLabel,
                data: dataTarget,
                type: 'line'
            }
        ],
        options: {
            chart: {
                toolbar: {
                    show: false,
                    tools: {
                        zoom: false
                    }
                }
            },
            markers: {
                size: 2,
                strokeColors: '#413799',
                strokeWidth: 2,
                colors: ['#413799'],
                width: 10
            },
            tooltip: {
                //enabled: false,
                y: {
                    title: {
                        formatter: (seriesName) => seriesName
                    },
                    //formatter: (val: number, opts: any) => opts?.seriesIndex === 0 ? val.toString() : null
                    formatter: (val, { dataPointIndex, seriesIndex }) => {
                        const value = val + '%';
                        if (seriesIndex === 1)
                            return value + `: ${buildTargetsParamsString({ dataPointIndex })}`;
                        return value;
                    }
                }
            },
            responsive: [
                {
                    breakpoint: 779,
                    options: {
                        chart: {
                            width: 760
                        }
                    }
                },
                {
                    breakpoint: 400,
                    options: {
                        chart: {
                            width: 350
                        }
                    }
                }
            ],
            dataLabels: {
                enabled: false
            },
            legend: {
                floating: true,
                offsetY: -165,
                offsetX: -160,
                fontSize: '10px',
                markers: {
                    width: 8,
                    height: 8
                }
            },
            stroke: {
                width: 1,
                curve: 'straight'
            },
            xaxis: {
                categories: labels.map(e => (0, dateUtils_1.toDayMonth)(e)),
                labels: {
                    style: {
                        fontSize: '8px'
                    }
                }
            },
            yaxis: {
                stepSize: 25,
                min: 0,
                max: 100,
                labels: {
                    formatter: function (val) {
                        return val + "%";
                    }
                }
            },
            colors: ['#e72c2c', '#1453e7'],
        }
    };
    // @ts-ignore
    // @ts-ignore
    // @ts-ignore
    // @ts-ignore
    return react_1.default.createElement(common_1.Plate, { w: "60%", padding: "20px 0 0 0", style: { position: 'relative' }, className: 'plate-chart' },
        (isLoading || isDataLoading) &&
            react_1.default.createElement(CircularProgress_1.default, { className: "chart-select", size: 20, style: {
                    left: '20px',
                    top: '-10px'
                } }),
        react_1.default.createElement("div", { id: "target-charts" }),
        react_1.default.createElement(ChartSelect_1.ChartSelect, { options: exerciseList === null || exerciseList === void 0 ? void 0 : exerciseList.map(e => ({ name: e.exercise_translation__name, value: e.slug })), style: { textTransform: 'capitalize' }, onChange: handleExerciseChange, value: exerciseKey }),
        react_1.default.createElement(react_apexcharts_1.default, { options: targetsState.options, series: targetsState.series, width: '440px', height: "185px" }));
};
exports.default = TargetLines;
